import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";
import * as user from "@/store/users";
import * as questions from "@/store/questions";
import * as app from "@/store/app";
import VuexPersistence from "vuex-persist";

Vue.use(Vuex);

const vuexLocal = new VuexPersistence<RootState>({
  storage: window.localStorage,
});

export interface RootState {
  appModule: app.AppState;
  userprofileModule: user.AppState;
  questionModule: questions.AppState;
}

const store: StoreOptions<RootState> = {
  modules: {
    appModule: app.default,
    userprofileModule: user.default,
    questionModule: questions.default,
  },
  plugins: [vuexLocal.plugin],
};

export default new Vuex.Store<RootState>(store);
